module.exports = __webpack_public_path__ + "img/reserve.efd4b2a7.svg";